import {
  ImportantPerson,
  ImportantPersonRole,
} from '@lyceo/homi/pupils/util-models';
import { PersonProfileDto } from '../pupil/pupil.dto';

export function mapPupilProfileToImportantPerson(
  personProfileDto: PersonProfileDto,
): ImportantPerson[] {
  if (!personProfileDto.pupil?.importantPersons) {
    return [];
  }
  return personProfileDto.pupil?.importantPersons.map((importantPersonDto) => ({
    id: importantPersonDto.id,
    firstName: importantPersonDto.firstName,
    lastName: importantPersonDto.lastName,
    emailAddress: importantPersonDto.emailAddress,
    role: importantPersonDto.role as ImportantPersonRole,
  }));
}
